import { Header, Rating, Divider } from "semantic-ui-react";

const StarRating = (props) => {
  const { selectedJob, setSelectedJob, handleChangeFieldString } = props;

  const handleChange = (e, data) => {
    handleChangeFieldString(e, { id: "rating", value: data.rating });
    console.log(data.rating);
  };

  return (
    <div>
      <div
        style={{ display: "flex", justifyContent: "center", margin: "10px" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Header
            content={
              selectedJob.rating
                ? `${parseInt(selectedJob.rating)} Stars`
                : null
            }
          />
          <Rating
            size="huge"
            icon="star"
            maxRating={5}
            onRate={handleChange}
            rating={parseInt(selectedJob.rating)}
          />
        </div>
      </div>
    </div>
  );
};
export default StarRating;
